import './tooltip.css';
import React, { useEffect, useState } from 'react'
import { store } from '../../../app/store';
import { postAPI } from '../../../app/api';
import './tooltip.css';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';
import Excel from '../../../components/Excel/Excel';
import { DownloadOutlined } from '@ant-design/icons';

export default function List() {

    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const store_data = JSON.parse(store());
    const [Customers, setCustomers] = useState([]);

    // Permission states
    const [canView, setCanView] = useState(false);
    const [canExport, setCanExport] = useState(false);

    // Email modal states
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [emailSubject, setEmailSubject] = useState('');
    const [emailMessage, setEmailMessage] = useState('');
    const [isSending, setIsSending] = useState(false);

    const fetchCustomers = async () => {
        const filter = { org_id: store_data?.org_id }
        const response = await postAPI("/customers/list", filter);
        if (response?.status) {
            setCustomers(response?.data)
        } else {
            setCustomers([])
        }
    }

    // Filter states
    const [filterName, setFilterName] = useState("");
    const [filterEmail, setFilterEmail] = useState("");
    const [filterContact, setFilterContact] = useState("");
    const [filteredCustomers, setFilteredCustomers] = useState([]);

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanView(true);
                setCanExport(true);
                fetchCustomers();
            } else {
                const viewAllowed = await hasPermission("SETTINGS", "Customers", "VIEW");
                const exportAllowed = await hasPermission("SETTINGS", "Customers", "EXPORT");
                setCanView(viewAllowed);
                setCanExport(exportAllowed);
                if (viewAllowed) {
                    fetchCustomers();
                }
            }
        };
        checkPermissions();
    }, [])

    // Filtering logic
    useEffect(() => {
        let data = Customers;
        if (filterName) {
            data = data.filter(c => (c.name || "").toLowerCase().includes(filterName.toLowerCase()));
        }
        if (filterEmail) {
            data = data.filter(c => (c.email || "").toLowerCase().includes(filterEmail.toLowerCase()));
        }
        if (filterContact) {
            data = data.filter(c => (c.contact_number || "").toLowerCase().includes(filterContact.toLowerCase()));
        }
        setFilteredCustomers(data);
    }, [Customers, filterName, filterEmail, filterContact]);

    const handleChangeStatus = async (id, status) => {
        // implement status change logic
    }
    const handleRemove = async id => {
        // implement remove logic
    }

    // Dummy handlers for edit (replace with real props if needed)
    const setIsEdit = () => { };
    const setEditId = () => { };
    const PopupID = '';

    const blockCustomer = async (customer) => {
        
        try {
            const filter = { org_id: store_data?.org_id, username: customer.username, is_block: customer.is_block ? 0 : 1};
            const response = await postAPI("/customers/block-unblock", {...filter, user: store_data});
            if (response?.status) {
                alert(`Customer ${customer.is_block ? 'unblocked' : 'blocked'} successfully!`);
                fetchCustomers();
            } else {
                alert(response?.message || 'Failed to update customer status');
            }
        } catch (error) {
            console.error('Error blocking/unblocking customer:', error);
            alert('An error occurred while updating customer status');
        }

    }
    const sendReply = (customer) => {
        setSelectedCustomer(customer);
        setEmailSubject('');
        setEmailMessage('');
        setShowEmailModal(true);
    }

    const handleSendEmail = async () => {
        if (!emailSubject.trim() || !emailMessage.trim()) {
            alert('Please fill in both subject and message');
            return;
        }

        setIsSending(true);
        try {
            const emailData = {
                to: selectedCustomer.email,
                subject: emailSubject,
                message: emailMessage,
                customer_name: selectedCustomer.name,
                org_id: store_data?.org_id
            };

            const response = await postAPI("/customers/send-email", emailData);

            if (response?.status) {
                alert('Email sent successfully!');
                setShowEmailModal(false);
                setSelectedCustomer(null);
                setEmailSubject('');
                setEmailMessage('');
            } else {
                alert(response?.message || 'Failed to send email');
            }
        } catch (error) {
            console.error('Error sending email:', error);
            alert('An error occurred while sending the email');
        } finally {
            setIsSending(false);
        }
    }

    const handleCloseModal = () => {
        if (!isSending) {
            setShowEmailModal(false);
            setSelectedCustomer(null);
            setEmailSubject('');
            setEmailMessage('');
        }
    }

    return (
        <>
            {/* Email Modal */}
            {showEmailModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Send Email to {selectedCustomer?.name}</h5>
                                <button type="button" className="btn-close" onClick={handleCloseModal} disabled={isSending}></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label">To:</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        value={selectedCustomer?.email || ''}
                                        disabled
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Subject: <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={emailSubject}
                                        onChange={(e) => setEmailSubject(e.target.value)}
                                        placeholder="Enter email subject"
                                        disabled={isSending}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Message: <span className="text-danger">*</span></label>
                                    <textarea
                                        className="form-control"
                                        rows="8"
                                        value={emailMessage}
                                        onChange={(e) => setEmailMessage(e.target.value)}
                                        placeholder="Enter your message"
                                        disabled={isSending}
                                    ></textarea>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={handleCloseModal}
                                    disabled={isSending}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleSendEmail}
                                    disabled={isSending}
                                >
                                    {isSending ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Sending...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fa fa-paper-plane me-2"></i>
                                            Send Email
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Filter UI */}
            {/* <div className="row mb-2">
                <div className="col-md-3">
                    <input type="text" className="form-control" placeholder="Filter by name" value={filterName} onChange={e => setFilterName(e.target.value)} />
                </div>
                <div className="col-md-3">
                    <input type="text" className="form-control" placeholder="Filter by email" value={filterEmail} onChange={e => setFilterEmail(e.target.value)} />
                </div>
                <div className="col-md-3">
                    <input type="text" className="form-control" placeholder="Filter by contact" value={filterContact} onChange={e => setFilterContact(e.target.value)} />
                </div>
                <div className="col-md-2">
                    <button type='button' className='btn btn-primary'><i className='fa fa-search'></i></button>
                </div>
                <div className="col-md-1">
                    <div className="container-fluid mb-3 gap-2 p-0 d-flex justify-content-end">
                        <button className="btn btn-primary btn-sm" disabled={!canExport}>
                            <Excel
                                data={{ Name: "Customers", Data: filteredCustomers }}
                                filename="customers-export.xlsx"
                            >
                                <DownloadOutlined /> Export
                            </Excel>
                        </button>
                    </div>
                </div>
            </div> */}
            <div className="container-fluid mb-3 gap-2 p-0 d-flex justify-content-end">
                <button className="btn btn-primary btn-sm" disabled={!canExport}>
                    <Excel
                        data={{ Name: "Customers", Data: filteredCustomers }}
                        filename="customers-export.xlsx"
                    >
                        <DownloadOutlined /> Export
                    </Excel>
                </button>
            </div>

            <table className="table card-table">
                <thead>
                    <tr>
                        <th>Image</th>
                        <th>Student</th>
                        <th>Email</th>
                        <th>Contact Number</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody className="table-border-bottom-0">
                    {
                        !canView ? (
                            <tr>
                                <td colSpan="4" className="text-center text-danger py-4">
                                    You do not have permission to view this page.
                                </td>
                            </tr>
                        ) : Customers && Customers.length > 0 ?
                            Customers.map((val, index) => (
                                <tr key={index + 1}>
                                    <td><img src={val?.image} alt={val?.name} style={{ height: '30px', borderRadius: '50%' }} /></td>
                                    <td>{val?.name}<br />{val?.email}</td>
                                    <td>{val?.email}</td>
                                    <td>{val?.contact_number}</td>
                                    <td>
                                        <button className="btn btn-sm btn-primary me-2" onClick={() => sendReply(val)}> Reply </button>
                                        <button className={`btn btn-sm ${val?.is_block ? 'btn-warning' : 'btn-danger'}`} onClick={() => blockCustomer(val)} title={val?.is_block ? 'Unblock Customer' : 'Block Customer'}>
                                            {val?.is_block ? 'Unblock' : 'Block'}
                                        </button>
                                    </td>
                                </tr>
                            ))
                            : ''
                    }
                </tbody>
            </table>
        </>
    )
}
